export const GET_ORDERS = "GET_ORDERS";
export const GET_ORDERS_STARTED = `${GET_ORDERS}_STARTED`;
export const GET_ORDERS_SUCCEED = `${GET_ORDERS}_SUCCEED`;
export const GET_ORDERS_FAILED = `${GET_ORDERS}_FAILED`;



// WEBPACK FOOTER //
// ./src/redux/actions/types/ordersActionTypes.js